export const MIN_PASSWORD_LENGTH = 8;
export const UPPERCASE_REGEX = /(?=.*[A-Z])/;
export const SPECIAL_CHARACTER_REGEX = /(?=.*\W)/;
export const MIN_LENGTH_REGEX = /.{8,}/;
